import request from "@/utils/http";

// 登录
export const rejectLogin = (date: any) => {
  return request.post(`/user/login/sms`, date);
};

// 验证码
export const validations = (phone: any) => {
  return request({
    url: `/sms/${phone}/code`,
    method: "get",
  });
};

// 获取home页面的产品列表信息
export const ProductList = () => {
  return request({
    url: `/product`,
    method: "get",
  });
};

//用户信息
export const userInfo = () => {
  return request({
    url: "/user",
    method: "get",
  });
};

// 获取汽车信息
export const information = () => {
  return request({
    url: "/brand",
    method: "get",
  });
};

// 获取品牌
export const ibmfunction = () => {
  return request({
    url: "/brand/hot",
    method: "get",
  });
};

// 新增预约订单
export const insertMation = (data?: any) => {
  return request({
    url: "/order/insert",
    method: "post",
    data,
  });
};

// 门店列表
export const shopServer = (query: any) => {
  return request({
    url: "/enterprise",
    method: "get",
    params: query
  });
};

// 获取用户报告列表
export const orderIds = (query: any) => {
  return request({
    url: `/order`,
    method: "get",
    params: query,
  });
};

// 用户详情
export const userDetails = (query: any) => {
  return request({
    url: `/order/detail`,
    method: "get",
    params: query,
  });
}

// 用户获取预约订单详情
export const userOrderFind = (query: any) => {
  return request({
    url: `/order/find`,
    method: "get",
    params: query,
  });
}

// 用户取消预约订单
export const ancelOrder = (orderId: any) => {
  return request({
    url: `/order/${orderId}`,
    method: "put",
  });
}

// 获取检测师订单
export const detectionOrderIds = (query: any) => {
  return request({
    url: `/detection`,
    method: "get",
    params: query,
  });
}

// 检测师详情
export const detailTails = (orderId: any) => {
  return request({
    url: `/detection/details`,
    method: "get",
    params: orderId
  });
}

// 开始检测
export const orderDetection = (query: any) => {
  return request({
    url: `/order/recur`,
    method: "get",
    params: query
  });
}




// 报告
export const titlePages = (orderId: any) => {
  return request({
    url: `/report/${orderId}`,
    method: "get",
  });
};

export const upload = (data?: any) => {
  return request({
    url: "/upload",
    method: "post",
    data,
  });
};

export const uploadBase64 = (data?: any) => {
  return request({
    url: "/upload/base64",
    method: "post",
    data,
  });
};

export const driverOcr = (data?: any) => {
  return request({
    url: "/upload/driverliscenseocr",
    method: "post",
    data,
  });
};

export const advertisement = (params?: any) => {
  return request({
    url: "/advertisement",
    method: "get",
    params,
  });
};

export const getReportExample = (params?: any) => {
  return request({
    url: "/advertisement/sample",
    method: "get",
    params,
  });
};

export const getUserInfo = (params?: any) => {
  return request({
    url: "/user",
    method: "get",
    params,
  });
};

export const getAreas = (params?: any) => {
  return request({
    url: "/areas",
    method: "get",
    params,
  });
};

// 中汽研报告
export const getReport = (orderId: any) => {
  return request({
    url: `/report/rglReport/${orderId}`,
    method: "get",
  });
}

// openID
export const getOperId = (code: any) => {
  return request({
    url: `/wechat/${code}/mp`,
    method: "get",
  });
}

// 预订单
export const postAppId = (data: any) => {
  return request({
    url: `/WeChat/pay/orderPay`,
    method: "post",
    data: data
  });
}

// 查询账户列表信息
export const getAccount = () => {
  return request({
    url: `/neEnterpriseAccount/getAccount`,
    method: "get",
  });
}

// 门店订单
export const accountOrderPay = (data: any) => {
  return request({
    url: `/WeChat/pay/accountOrderPay`,
    method: "post",
    data
  });
}

// 获取用户扫码
export const scanCode = (code:any)=>{
  return request({
    url: `/scan/code/${code}`,
    method: "get",
  });
}


// 订单信息
export const producpe = (productType: any) => {
  return request({
    url: `/product/getProductByType?productType=${productType}`,
    method: "get",
  });
}




export const getrglOnLine = (orderId: any) => {
  return request({
    url: `/report/rglOnLineReport/${orderId}`,
    // url: `/report/zjOnLineReport`,
    method: "get",
  });
}


// 生成订单
export const getorders = (data: any) => {
  return request({
    url: 'order/generateOrder',
    method: 'post',
    data: data
  })
}


// 用户登录判断门店账户还是普通账户
export const employeesList = () => {
  return request({
    url: "employees",
    method: 'get',
  })
}

// 查询汽车品牌
export const barnds = () => {
  return request({
    // url: "/carType/brand",
    /* 2024/1/18修改 */
    url: "/car/model/brand",  
    method: 'get',
  })
}

//查询车系
export const carSeries = (brandId: any) => {
  return request({
    // url: `/carType/carSeries?brandId=` + brandId,
     /* 2024/1/18修改 */
    url: `/car/model/carSeries?brandId=` + brandId,
    method: 'get',
  })
}

//查询年份
export const yearbran = (seriesId: any) => {
  return request({
    // url: `/carType/year?seriesId=` + seriesId,
     /* 2024/1/18修改 */
    url: `/car/model/year?seriesId=` + seriesId,
    method: 'get',
  })
}

//查询款式
export const model = (seriesId: any, year: any) => {
  return request({
    url: `/carType/model?seriesId=${seriesId}&year=${year}`,
    method: 'get',
  })
}

//检测师查询门店所有订单
export const getReservationOrder = (query: any) => {
  return request({
    url: `/detection`,
    method: "get",
    params: query,
  });
}

//检测师获取订单详情
export const getOrderDateils = (query: any) => {
  return request({
    url: `/detection/details`,
    method: "get",
    params: query,
  });
}
//检测师获取门店设备
export const getDevices = () => {
  return request({
    url: `/detection/getDevice`,
    method: "get",
  });
}
//检测师开始检测
export const startDetection = (data: any) => {
  return request({
    url: `/detection/startDetection`,
    method: 'post',
    data: data
  });
}






